import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '../../../../../common/Tooltip'
import { MultiSelectControl } from '../../../../../common/MultiSelectControl'
import { Tag } from '../../../../../common/Tag'

export const RolesSelector = ({
  rowOptions = [],
  disabled,
  editMode,
  onRolesInputChange,
  roles,
}) => {
  const [value, setValue] = useState(rowOptions)
  const generateTaggedRolesList = (rolesToDisplay = 3) => {
    const visibleTaggedRoles = rowOptions
      .slice(0, rolesToDisplay)
      .map(({ label }) => <Tag key={label} label={label} />)
    const toolTipRoles = rowOptions
      .slice(rolesToDisplay, rowOptions.length)
      .map(({ label }) => <Tag key={label} label={label} />)
    return (
      <div className="tenant-members__tagged_roles">
        {visibleTaggedRoles}
        {toolTipRoles.length ? (
          <Tooltip
            title={
              <span className="wb-button--tertiary wb-margin-start-xxs">{`+${
                rowOptions.length - 3
              } Roles`}</span>
            }
            content={toolTipRoles}
          />
        ) : null}
      </div>
    )
  }

  return (
    <div className="tenant-members__roles-form">
      {editMode ? (
        <MultiSelectControl
          disabled={disabled}
          items={roles}
          closeMenuOnSelect={false}
          value={value}
          onChange={setValue}
          onBlur={() => onRolesInputChange(value)}
          onMenuClose={() => onRolesInputChange(value)}
        />
      ) : (
        generateTaggedRolesList()
      )}
    </div>
  )
}

RolesSelector.propTypes = {
  rowOptions: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string })),
  disabled: PropTypes.bool,
  editMode: PropTypes.bool,
  roles: PropTypes.array,
  onRolesInputChange: PropTypes.func,
}
